import React, { createContext, useContext } from 'react';

const SetupWizardContext = createContext();

export const useSetupWizard = () => {
  const context = useContext(SetupWizardContext);
  if (!context) {
    throw new Error('useSetupWizard must be used within SetupWizardProvider');
  }
  return context;
};

const SetupWizardProvider = ({ 
  children, 
  currentStep, 
  totalSteps, 
  completedSteps, 
  stepData, 
  validationErrors,
  onStepComplete,
  onStepValidation
}) => {
  const value = {
    currentStep,
    totalSteps,
    completedSteps,
    stepData,
    validationErrors,
    onStepComplete,
    onStepValidation,
    isStepCompleted: (stepNumber) => completedSteps.includes(stepNumber),
    getStepData: (stepNumber) => stepData[stepNumber] || {},
    hasValidationErrors: (stepNumber) => validationErrors[stepNumber] && validationErrors[stepNumber].length > 0
  };

  return (
    <SetupWizardContext.Provider value={value}>
      {children}
    </SetupWizardContext.Provider>
  );
};

export default SetupWizardProvider;

